import { useUI, WORLDS } from '../lib/store'
import type { World } from '../lib/store'

/**
 * topbar-ports.tsx — the forge's topbar PORTS (rule 0: ports stay; the config
 * is the source). brandLeading (the ☰ nav trigger), the brand theme-cycle
 * handler, and the compact INLINE actions (spoons chip + mode toggle) — the
 * same controls the legacy Port-F bar carried, now canon-slot ports. Data
 * (brandName/brandLabel/brandMark) comes from `chrome.topbar`.
 */
import { ShellRailToggle } from '@p31ca/design-core/compositions'

export function topbarPorts() {
  const { mode, setMode, spoons, togglePalette, world } = useUI()
  return {
    brandLeading: <ShellRailToggle />,
    onBrandClick: () => {
      const next = WORLDS[(WORLDS.indexOf(world) + 1) % WORLDS.length] as World
      useUI.getState().setWorld(next)
      // A15 (layout gate): the brand click must change data-theme SYNCHRONOUSLY
      // (the App effect applies it on the next React commit; the gate reads it
      // immediately). The forge's world IS the canon theme — write it direct.
      document.documentElement.dataset.theme = next
    },
    actions: (
      <>
        <span className="posner-topbar__action spoon-chip" data-cap="spoons">
          spoons {spoons}/5
        </span>
        <button
          type="button"
          className="posner-topbar__action btn btn--ghost"
          data-cap="theme"
          onClick={() => setMode(mode === 'light' ? 'dark' : 'light')}
        >
          {mode === 'light' ? '◐ dark' : '◑ light'}
        </button>
      </>
    ),
  }
}

export default topbarPorts